import { Danish } from "flatpickr/dist/l10n/da.js";
import { Swedish } from "flatpickr/dist/l10n/sv.js";
import { Norwegian } from "flatpickr/dist/l10n/no.js";
import { english } from "flatpickr/dist/l10n/default.js";
import i18n from "@/i18n";

// flatpickr ships its own month/day name translations, independent of
// vue-i18n. Map the active app locale onto the matching flatpickr l10n pack so
// the calendar header, month dropdown and weekday labels follow the UI
// language. Both Norwegian variants share the same flatpickr pack.
const flatpickrLocales: Record<string, object> = {
  da: Danish,
  en: english,
  sv: Swedish,
  nb: Norwegian,
  nn: Norwegian
};

export const getFlatpickrLocale = (): object =>
  flatpickrLocales[
    (i18n.global.locale as unknown as { value: string }).value
  ] ?? Danish;
